import {Divider, Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay} from "@chakra-ui/react";
import React from "react";
import {scrollbarCss} from "../../../theme/theme";

interface CustomModalProps {
    isOpen: boolean;
    onClose: () => void;
    content: React.ReactNode;
    title?: string | React.ReactNode;
    hasSeparator?: boolean;
}

export function CustomModal({isOpen, onClose, content, title, hasSeparator = false}: CustomModalProps) {
    return (
        <Modal isOpen={isOpen} onClose={onClose} isCentered={true} blockScrollOnMount={false}>
            <ModalOverlay/>
            <ModalContent minW={"60%"} maxH={"90%"}  zIndex={200} borderRadius={"16px"}>
                <ModalHeader textAlign={"center"} textColor={"primary.400"}>{title}</ModalHeader>
                <ModalCloseButton/>
                {hasSeparator && <Divider/>}
                <ModalBody overflowY={"auto"} css={scrollbarCss({marginRight: 48})}>
                    {content}
                </ModalBody>
            </ModalContent>
        </Modal>
    );
}
